module.exports = __webpack_public_path__ + "img/full7-min.90163035.png";